import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

type RuntimeConfig = {
  apiBasePath?: string;
  filesBasePath?: string;
};

function configuredUrl(value: unknown, fallback: string): string {
  return typeof value === 'string' && value.trim().length > 0 ? value.trim().replace(/\/$/, '') : fallback;
}

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private config: RuntimeConfig = {};

  async load(): Promise<void> {
    try {
      const response = await fetch('assets/runtime-config.json', { cache: 'no-store' });
      if (response.ok) {
        this.config = await response.json() as RuntimeConfig;
      }
    } catch {
      // En local o si el archivo no está disponible se usan los valores compilados.
      this.config = {};
    }
  }

  get apiBasePath(): string {
    return configuredUrl(this.config.apiBasePath, environment.API_BASE_PATH);
  }

  get filesBasePath(): string {
    return configuredUrl(this.config.filesBasePath, environment.FILES_BASE_PATH);
  }
}
